import * as React from 'react';
import type { WhyUsCta } from '../../types/whyus-landing';

interface FinalCTAProps {
  loginUrl: string;
  produceUrl: string;
  bolsonUrl: string;
  cta: WhyUsCta;
}

export function FinalCTA({ loginUrl, produceUrl, bolsonUrl, cta }: FinalCTAProps) {
  return (
    <section className="whyus-final-cta">
      <style>{`
        .whyus-final-cta {
          padding: 80px 24px;
          background: #f0fdf0;
          text-align: center;
        }
        .whyus-final-inner {
          max-width: 640px;
          margin: 0 auto;
        }
        .whyus-final-cta h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 12px;
        }
        .whyus-final-cta p {
          font-size: 18px;
          color: #555;
          margin: 0 0 36px;
        }
        .whyus-final-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .whyus-final-cta .whyus-btn-secondary {
          color: #1a1a1a;
          border-color: rgba(0,0,0,0.25);
        }
        .whyus-final-cta .whyus-btn-secondary:hover {
          background: rgba(0,0,0,0.05);
          border-color: rgba(0,0,0,0.4);
          color: #1a1a1a;
        }
        @media (max-width: 640px) {
          .whyus-final-cta {
            padding: 60px 24px;
          }
          .whyus-final-cta h2 {
            font-size: 24px;
          }
          .whyus-final-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .whyus-final-ctas a {
            justify-content: center;
          }
        }
      `}</style>
      <div className="whyus-final-inner">
        <h2>{cta.title}</h2>
        <p>{cta.body}</p>
        <div className="whyus-final-ctas">
          <a href={loginUrl} className="whyus-btn-primary">
            <i className="fa fa-user-plus" /> {cta.primary}
          </a>
          <a href={produceUrl} className="whyus-btn-secondary">
            <i className="fa fa-leaf" /> {cta.secondary}
          </a>
          <a href={bolsonUrl} className="whyus-btn-secondary">
            <i className="fa fa-shopping-basket" /> {cta.bolson}
          </a>
        </div>
      </div>
    </section>
  );
}
